export default "__VITE_ASSET__Cp0fVF5g__"